import { render, staticRenderFns } from "./ProjectProposalUploadFiles.vue?vue&type=template&id=6b981cf0&scoped=true&"
import script from "./ProjectProposalUploadFiles.vue?vue&type=script&lang=ts&"
export * from "./ProjectProposalUploadFiles.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectProposalUploadFiles.vue?vue&type=style&index=0&id=6b981cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b981cf0",
  null
  
)

export default component.exports